import React from "react"
import { QRCodeSVG } from "qrcode.react"
import { useTranslation } from "react-i18next"

import { scale } from "utils"

const PloptfcPagerQrCode = (props) => {
  const { templateType, printData } = props

  const {
    subdomain,
    domain,
    customDomainName,
    _id: orderId
  } = printData

  const [t] = useTranslation()

  const website =
    !!customDomainName
      ? `https://${customDomainName}/pager/${orderId}`
      : `https://${subdomain}.${domain}/pager/${orderId}`

  const styles =
    templateType === "thermal" ? stylesThermal : stylesOthers

  const qrCodeSize =
    templateType === "thermal"
      ? 200 / window.devicePixelRatio
      : 100

  return (
    <div style={styles["container"]}>
      <div style={{ ...styles["text"], ...styles["center"] }}>
        {t("جهت_اطلاع_از_آخرین_وضعیت_سفارش_خود_لطفا_کد_QR_زیر_را_اسکن_کنید")}
      </div>

      <div style={styles["qrCenter"]}>
        <QRCodeSVG
          size={qrCodeSize}
          value={website}
        />
      </div>
    </div>
  )
}

const stylesThermal = {
  container: {
    paddingBottom: scale("10px"),
  },

  text: {
    fontWeight: "bold",
    fontSize: "calc(20px/ var(--pixel-ratio))",
  },

  center: {
    textAlign: "center"
  },
  qrCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "calc(15px/ var(--pixel-ratio))"
  }
}

const stylesOthers = {
  container: {
    paddingTop: "5px"
  },

  text: {
    fontWeight: "bold",
    fontSize: "14px",
  },

  center: {
    textAlign: "center"
  },

  qrCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "5px"
  }
}

export default PloptfcPagerQrCode